import { isEmpty, isFunction, isString, startCase } from 'lodash/fp';

import analyticsClient from '.';

/**
 * Little helper fn that enabled analytics tracking per element.
 *
 * Usage:
 * `<MyElement onClick={elementAnalytics(this.props, this.props.onClick, 'clicked')} />`.
 *
 * @param {object} props - Element properties, e.g. {analytics: {label: 'foobar'}, name: 'firstName'}.
 * @param {Function} originalFn - Original fn to wrap with analytics call.
 * @param {string} action - Action, e.g. 'clicked' or 'changed'.
 */
const elementAnalytics =
  // @ts-expect-error - Automatic, Please fix when editing this file


    (props, originalFn, action = 'changed') =>
    // @ts-expect-error - Automatic, Please fix when editing this file
    (...args) => {
      const { analytics, children, name } = props;

      const linkText = isString(children) && !isEmpty(children) ? startCase(children) : undefined;
      const label = analytics?.label || startCase(name) || linkText;

      if (label) {
        analyticsClient.publish('action', {
          action,
          component: analytics?.component ?? 'element',
          label,
        });
      }

      // Original fn to wrap
      if (isFunction(originalFn)) {
        originalFn(...args);
      }
    };

export default elementAnalytics;
